export default __webpack_public_path__ + "static/media/projectLocationImg.cd7ae330.png";